import { render, staticRenderFns } from "./receiveItemList.vue?vue&type=template&id=29d1b3c0&"
import script from "./receiveItemList.vue?vue&type=script&lang=js&"
export * from "./receiveItemList.vue?vue&type=script&lang=js&"
import style0 from "./receiveItemList.vue?vue&type=style&index=0&id=29d1b3c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports